import './SearchBox2.scss'
import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Input, Button } from 'antd'


export default ({ currentQuery, onChange, onSearch, loading }) => {
  const { t } = useTranslation()
  const searchInProgress = useRef(false)
  const enterKeyDown = useRef(false)

  const handleKeyDown = event => {
    if (event.key !== 'Enter' && event.keyCode !== 13) return
    if (enterKeyDown.current) {
      event.preventDefault()
      event.stopPropagation()
      return
    }
    enterKeyDown.current = true
  }

  const handleKeyUp = event => {
    if (event.key === 'Enter' || event.keyCode === 13) {
      enterKeyDown.current = false
    }
  }

  const handleSearch = async (...args) => {
    const event = args[1] || args[0]
    if (event && (event.key === 'Enter' || event.keyCode === 13) && enterKeyDown.current) return
    if (loading || searchInProgress.current) return

    searchInProgress.current = true
    try {
      return await onSearch(...args)
    } finally {
      searchInProgress.current = false
    }
  }

  return (
    <div id="searchbox">
      <div class="inputSearch">
        <Input placeholder={t('messages.aml.enterRutNumber')} onChange={onChange} value={currentQuery} onKeyDown={handleKeyDown} onKeyUp={handleKeyUp} onBlur={() => { enterKeyDown.current = false }} onPressEnter={event => handleSearch(currentQuery, event)} allowClear style={{width: 500}}/>
      </div>
      <div class="searchBtn" >
        <Button icon={loading ? 'loading' : null} type="primary" disabled={loading} onClick={() => handleSearch(currentQuery)} style={{width: 350}}>Solicitar Certificado</Button>
      </div>
    </div>
  )
}

